const MINUTE_MS = 60_000

/**
 * Сколько осталось до автоотмены спора — с точностью до минуты, в формате «Чч Мм».
 * Срок прошёл, а крон ещё не отработал (он ходит раз в пять минут) — «скоро».
 */
export function formatAutoCancelRemaining(ms: number): string {
  if (ms <= 0) {
    return 'скоро'
  }

  const minutes = Math.floor(ms / MINUTE_MS)
  if (minutes === 0) {
    return '< 1м'
  }

  const hours = Math.floor(minutes / 60)

  return hours > 0 ? `${hours}ч ${minutes % 60}м` : `${minutes}м`
}

/**
 * Через сколько миллисекунд сменится текст отсчёта; null — больше не сменится.
 * Текст меняется, когда целых минут становится меньше, то есть через остаток от минуты и ещё 1 мс.
 */
export function msUntilAutoCancelTextChanges(ms: number): number | null {
  return ms <= 0 ? null : (ms % MINUTE_MS) + 1
}
